(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["whatsapp-order"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var link = event.target.closest ? event.target.closest('[data-wa-product]') : null;
    if (!link) return;
    var number = link.getAttribute('data-wa-number');
    if (!number) { event.preventDefault(); return; }
    var input = document.querySelector('.pdp .quantity__input, .pdp input[name="quantity"]');
    var qty = input ? parseInt(input.value, 10) : 1;
    if (!qty || qty < 1) qty = 1;
    var nl = String.fromCharCode(10);
    var text = link.getAttribute('data-wa-text') + nl + 'Quantity: ' + qty + nl + window.location.href;
    link.href = 'https://wa.me/' + number + '?text=' + encodeURIComponent(text);
  });
  } catch(e) { console.error(e); }
})();

})();
